import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import { Container, Row, Col, Button, Jumbotron } from "reactstrap";
import InfiniteScroll from 'react-infinite-scroller';
import { getCookie, saveCookie } from "~/utils/cookie";
import assetPath from "~/utils/assetPath";
import {
  collectionColumn
} from "./helpers/elements";
import { isGamedistributionApp } from "~/utils/misc";

import styles from "./styles.scss";

class CollectionsComponent extends React.Component {
  static contextTypes = {
    fetch: PropTypes.func.isRequired
  };

  constructor(props) {
    // Set props
    super(props);

    // Set initial state
    this.state = {
      isLoadingCollections: false,
      hasMoreCollections: true,
      collectionType: getCookie("collectionType", "popular"),
      collectionPage: 1,
      collections: []
    };

    // Bind element functions
    this.collectionColumn = collectionColumn.bind(this);
  }

  //-----------------------------------------------------------------------
  // Lifecycle
  //-----------------------------------------------------------------------
  componentDidMount() {
    this.loadCollections()
  }

  shouldComponentUpdate() {
    return false;
  }

  //-----------------------------------------------------------------------
  // Handlers
  //-----------------------------------------------------------------------
  handleBottomReached = () => {
    this.loadCollections()
  };

  handleCollectionTypeClicked = (collectionType) => {
    saveCookie("collectionType", collectionType)
    this.setState({ collectionType, collectionPage: 1, hasMoreCollections: true, collections: [] })
    this.forceUpdate();
    setTimeout(this.loadCollections, 0)
  };

  handleLinkClick = event => {
    if (isGamedistributionApp()) {
      event.preventDefault();
      window.parent.postMessage({ event: "handleLinkClick", link: `${$(event.target).attr("data-href")}?platform=gamedistribution` }, "*")
    }
  }

  //-----------------------------------------------------------------------
  // Helpers
  //-----------------------------------------------------------------------
  loadCollections = () => {
    if (is.truthy(this.state.isLoadingCollections)) {
      return
    }

    this.state.isLoadingCollections = true

    this.context.fetch(`/api/unsplash/collections?type=${this.state.collectionType}&page=${this.state.collectionPage}&perPage=${18}`).then(response => response.json()).then((json) => {
      this.setState({ collectionPage: this.state.collectionPage + 1, hasMoreCollections: is.equal(json.length, 18), collections: _.concat(this.state.collections, json) })
      this.forceUpdate();

      _.delay(() => {
        $("#app").perfectScrollbar("update");
      }, 0)

      _.delay(() => {
        this.setState({ isLoadingCollections: false })
        this.forceUpdate();
      }, 160)
    });
  };

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <div id="collections_component">
        <Container id="headline_container">
          <Row>
            <Col>
            <div className="float-left">
              <h1>Popular puzzle collections</h1>
            </div>
            <div className="collection_type_container float-right">
              <h4 onClick={this.handleCollectionTypeClicked.bind(this, "popular")} className={classNames("float-right", { active: is.equal(this.state.collectionType, "popular") })}>Popular</h4>
              <h4 onClick={this.handleCollectionTypeClicked.bind(this, "curated")} className={classNames("float-right", { active: is.equal(this.state.collectionType, "curated") })}>Curated</h4>
            </div>
            </Col>
          </Row>
        </Container>

        <Container id="collections">
          <InfiniteScroll
            pageStart={0}
            loadMore={this.handleBottomReached}
            hasMore={this.state.hasMoreCollections}
            loader={<Row key={0}><Col><p className="collection_loader" key={0}>{is.above(this.state.collections.length, 0) && is.truthy(this.state.hasMoreCollections) ? 'Loading collections' : ''}</p></Col></Row>}
            useWindow={false}
            getScrollParent={() => document.getElementById("app")}
            threshold={128}
            initialLoad={false}
            >
            <For each="item" index="idx" of={_.chunk(this.state.collections, 3)}>
              <Row key={idx}>
                {this.collectionColumn(_.nth(item, 0))}
                {this.collectionColumn(_.nth(item, 1))}
                {this.collectionColumn(_.nth(item, 2))}
              </Row>
            </For>
          </InfiniteScroll>
        </Container>
      </div>
    );
  }
}

export default withStyles(styles)(CollectionsComponent);



// WEBPACK FOOTER //
// ./src/routes/collections/components/CollectionsComponent/index.js